"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FirestoreRefs_1 = require("./FirestoreRefs");
const AssignmentCompleteProvider_1 = require("./providers/AssignmentCompleteProvider");
const AssignmentContentProvider_1 = require("./providers/AssignmentContentProvider");
const AssignmentDataProvider_1 = require("./providers/AssignmentDataProvider");
const AssignmentMetaProvider_1 = require("./providers/AssignmentMetaProvider");
const AssignmentProvider_1 = require("./providers/AssignmentProvider");
const AssignmentSettingsProvider_1 = require("./providers/AssignmentSettingsProvider");
const BookmarkProvider_1 = require("./providers/BookmarkProvider");
const EntryProvider_1 = require("./providers/EntryProvider");
const GroupInviteProvider_1 = require("./providers/GroupInviteProvider");
const GroupProvider_1 = require("./providers/GroupProvider");
const InviteProvider_1 = require("./providers/InviteProvider");
const LessonModuleProvider_1 = require("./providers/LessonModuleProvider");
const RatingsProvider_1 = require("./providers/RatingsProvider");
const SessionProvider_1 = require("./providers/SessionProvider");
const TeacherEntryProvider_1 = require("./providers/TeacherEntryProvider");
const UpdateCollector_1 = require("./UpdateCollector");
class DefaultFirestoreDatabase {
    constructor(firestore, connectivityService) {
        const refs = new FirestoreRefs_1.FirestoreRefs(firestore);
        this.refs = refs;
        this.firestore = firestore;
        this.assignmentContent = new AssignmentContentProvider_1.AssignmentContentProvider(refs, connectivityService);
        this.assignmentSettings = new AssignmentSettingsProvider_1.AssignmentSettingsProvider(refs, connectivityService);
        this.metas = new AssignmentMetaProvider_1.AssignmentMetaProvider(refs, connectivityService, this.assignmentSettings);
        this.assignments = new AssignmentProvider_1.AssignmentProvider(this.assignmentContent, this.assignmentSettings);
        this.entries = new EntryProvider_1.EntryProvider(refs, connectivityService);
        this.teacherEntries = new TeacherEntryProvider_1.TeacherEntryProvider(refs, connectivityService);
        this.bookmarks = new BookmarkProvider_1.BookmarkProvider(refs, connectivityService);
        this.invites = new InviteProvider_1.InviteProvider(refs, connectivityService);
        this.assignmentData = new AssignmentDataProvider_1.AssignmentDataProvider(this.assignments, this.metas, this.entries);
        this.assignmentComplete = new AssignmentCompleteProvider_1.AssignmentCompleteProvider(this.assignmentContent, this.metas, this.assignmentSettings, this.teacherEntries);
        this.ratings = new RatingsProvider_1.RatingsProvider(refs, connectivityService);
        this.groupInvites = new GroupInviteProvider_1.GroupInviteProvider(refs, connectivityService);
        this.lessonModules = new LessonModuleProvider_1.LessonModuleProvider(refs, connectivityService);
        this.groups = new GroupProvider_1.GroupProvider(refs, connectivityService);
        this.sessions = new SessionProvider_1.SessionProvider(refs, connectivityService);
    }
    async write(updateFun) {
        const batch = this.firestore.batch();
        const collector = new UpdateCollector_1.UpdateCollector(batch, this.refs, noopLogger);
        await updateFun(collector);
        await collector.commitAllPendingMerges();
        await batch.commit();
    }
}
exports.default = DefaultFirestoreDatabase;
// TODO ED-542: Should use our contextual logger
const noopLogger = {
    info: () => {
        // do nothing
    },
    warn: () => {
        // do nothing
    },
    error: () => {
        // do nothing
    },
};
//# sourceMappingURL=DefaultFirestoreDatabase.js.map